import { render, staticRenderFns } from "./GpTabs.vue?vue&type=template&id=488142ca&"
import script from "./GpTabs.vue?vue&type=script&lang=js&"
export * from "./GpTabs.vue?vue&type=script&lang=js&"
import style0 from "./GpTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports